import { Language } from "@components/General/LanguageSelector/languageSelector.component";

const getLabel = (language: Language, variant?: string) => {
    if (!language) return variant === "small" ? "XX" : "Placeholder - XX";

    return variant === "small"
        ? language.languageCode.toUpperCase()
        : `${language.language} - ${language.languageCode.toUpperCase()}`;
};

export { getLabel };
